import { getEnvironmentConfig } from "@/config/environment";

export class ChatApiService {
  private readonly baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async sendMessage(message: string, businessUnitId: number, chatHistory: any[] = [], signal?: AbortSignal): Promise<any> {
    const requestBody = {
      message,
      business_unit_id: businessUnitId,
      chat_history: chatHistory
    };
    
    console.log('🚀 Chat API Request:');
    console.log('📍 Endpoint:', `${this.baseUrl}/api/v1/agent/chat`);
    console.log('🏢 Business Unit ID:', businessUnitId);
    console.log('💬 Message:', message);
    console.log('📜 Chat History Length:', chatHistory.length);
    console.log('📦 Full Request Body:', JSON.stringify(requestBody, null, 2));
    
    const response = await fetch(`${this.baseUrl}/api/v1/agent/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '1'
      },
      body: JSON.stringify(requestBody),
      signal: signal // Add abort signal support
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.text;
  }
}

// Factory function to get the appropriate service based on environment
export const getChatService = () => {
  const config = getEnvironmentConfig();
  return new ChatApiService(config.apiUrl);
};

// Export a singleton instance
export const chatService = getChatService();

